var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"eda-button",class:{
         'eda-button-secondary': _vm.secondary,
         'eda-button-secondary--disabled': _vm.secondary && _vm.disabled,
         'eda-button--invisible': !_vm.visible,
         'eda-button--disabled': !_vm.secondary && _vm.disabled,
         'eda-button--hover': _vm.hover,
         'eda-button--unselected': _vm.unselected,
         'eda-button--disabled-hide': _vm.disabled && _vm.hideDisabled,
         'eda-button--error': _vm.error
        },attrs:{"disabled":_vm.disabled,"type":_vm.type},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"eda-button__label",class:{'eda-button__label--hidden': _vm.loading}},[_vm._v("\n        "+_vm._s(_vm.label)+"\n        "),_vm._t("default")],2),_c('div',{staticClass:"eda-button__loader",class:{'eda-button__loader--hidden': !_vm.loading}},[_c('eda-ellipsis-loader',{attrs:{"color":_vm.secondary ? 'green' : 'white'}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }